module.exports = __webpack_public_path__ + "static/media/piano-e.d7b6a799.wav";